import { useSyncExternalStore } from "react";
import { getPostHogConsent, POSTHOG_CONSENT_CHANGED_EVENT, type PostHogConsentState } from "@/lib/posthog";
function subscribe(onStoreChange: () => void) {
  window.addEventListener(POSTHOG_CONSENT_CHANGED_EVENT, onStoreChange);
  window.addEventListener("storage", onStoreChange);
  return () => {
    window.removeEventListener(POSTHOG_CONSENT_CHANGED_EVENT, onStoreChange);
    window.removeEventListener("storage", onStoreChange);
  };
}
const getServerSnapshot = (): PostHogConsentState => null;
export function usePostHogConsent() {
  return useSyncExternalStore(subscribe, getPostHogConsent, getServerSnapshot);
}